<div class="template" [formGroup]="form">
    <div class="template-search-container">
        <span class="template-search-header">
            <span class="icon-books icon-left"></span>
            <label>Select a template:</label>
            <button hc-button buttonStyle="link" size="sm" (click)="onCreateSourceFromScratch()">
                Create source from scratch<span class="icon-right icon-chev-right"></span>
            </button>
        </span>

        <hc-search-bar
            #templateSearch
            placeholder="Search..."
            [autoSearch]="true"
            (triggerSearch)="search($event)"
        ></hc-search-bar>
    </div>
    <div class="template-list-container">
        <cdp-grid-states
            nameSingular="template"
            namePlural="templates"
            [loading]="loadingTemplates"
            [loadFailed]="loadingTemplatesFailed"
            [searchValue]="templateSearch.value"
            [dataSource]="templateDataSource"
            [allowAddNew]="false"
            (clearSearch)="templateSearch.clear()"
            (refresh)="loadTemplateList(true)"
        >
        </cdp-grid-states>
        <hc-radio-group formControlName="templateId" (change)="onTemplateClicked()">
            <label
                *ngFor="let template of templateDataSource.filteredData"
                #templateRow
                tabindex="0"
                class="template-row"
            >
                <span class="template-row-name">
                    <hc-radio-button [value]="template.templateId">
                        <span
                            [ngClass]="
                                template.template.tenantSource[0].sourceType === 'File'
                                    ? 'icon-folder-tree'
                                    : 'icon-database'
                            "
                        ></span>
                        <span [innerHTML]="template.name | highlight: templateSearch.value"></span>
                    </hc-radio-button>
                </span>
                <span class="template-row-entity-count">
                    <span class="icon-table icon-left"></span>
                    <span>{{ template.entityCount }} Entities</span>
                </span>
            </label>
        </hc-radio-group>
    </div>
</div>
